import { all } from "redux-saga/effects";
import { hoaDonDienTuSaga } from "./hoaDonDienTuSaga";
import { kyHieuHoaDonSaga } from "./kyHieuHoaDonSaga";
import { hoaDonDieuChinhThuCongSaga } from "./hoaDonDieuChinhThuCongSaga";

export default function* hoaDonSagaWrapper() {
  yield all([hoaDonDienTuSaga(), kyHieuHoaDonSaga(), hoaDonDieuChinhThuCongSaga()]);
}
